<template>
  <div>
    <breadcrumbs
      :crumbs="[{name:'Administrative Settings'},{name: 'Data Import', link:'Imports Select'}, {name:'Import File'}]"
    />
    <div class="col-md-12">
      <div class="row">
        <div class="portlet light">
          <div class="portlet-title">
            <div class="caption caption-md">
              <span class="caption-subject bold uppercase">Import File</span>
            </div>
            <div class="actions"
                 v-if="summary.exceptionsCount !== 0 && $refs.wizard != null && $refs.wizard.activeTabIndex == 2">
              <a class="btn btn-circle btn-icon-only btn-default" style="width:35px; height:35px; padding: 6px;"
                 @click.prevent="exportExceptions({filename, id: form, map: map.fields})">
                <img src="/static/global/img/csv-ico.svg" style="width:20px;">
              </a>
            </div>
          </div>
          <div class="portlet-body">
            <form-wizard
              title=""
              subtitle=""
              color="#d09f23"
              ref="wizard"
            >
              <tab-content title="Select Form" icon="fa fa-address-card-o">
                <div class="vue-good-table row">
                  <vue-good-table :columns="columns" :rows="forms" :pagination-options="{enabled: true}">
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'createdBy'">
                        {{ props.row.createdBy.user }} on {{ props.row.createdBy.date.date | formatDate }}
                      </span>
                      <span
                        v-else-if="props.column.field == 'lastModified' && showModification(props.row.lastModified)">
                        {{ props.row.lastModified.user }} on {{ props.row.lastModified.date.date | formatDate }}
                      </span>
                      <div v-else-if="props.column.field == 'after'" class="last-dropdown">
                        <actions-menu>
                          <actions-menu-item
                            title="Import File"
                            icon="fa-file-text-o"
                            @click.prevent="uploadFile(props.row.id)"
                          />
                          <actions-menu-item
                            title="Export Template"
                            icon="fa-cloud-download"
                            @click.prevent="exportTemplate(props.row.id)"
                          />
                        </actions-menu>
                      </div>
                      <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                    </template>
                  </vue-good-table>
                </div>
              </tab-content>
              <tab-content title="Map Fields"
                           icon="fa fa-keyboard-o"
              >
                <spinner v-if="loading"/>
                <div v-else>
                  <div class="upload-line">
                    <h5><b>File Name:</b></h5>
                    <ul style="padding-left: 5px; padding-top: 10px;">
                      <li v-for="file in files" style="list-style: none">{{ file.name }}</li>
                    </ul>
                  </div>
                  <div class="pull-left">
                    <vue-upload-component
                      ref="upload"
                      v-model="files"
                      @input-filter="inputFilter">
                      <a type="button" class="btn green">Add File</a>
                    </vue-upload-component>
                  </div>
                  <button @click="validateUploadAsync"
                          :disabled="!files.length"
                          data-style="expand-left"
                          class="btn green mt-ladda-btn ladda-button fileUpload"
                          style="margin-left: 5px"

                  >
                    <span class="ladda-label">Upload</span>
                  </button>
                  <div style="clear: both"></div>

                  <div class="form-group margin-top-15">
                    <label class="mt-checkbox mt-checkbox-outline">
                      Validation: ignore "required" rule
                      <input type="checkbox" v-model="ignoreRequired"/>
                      <span></span>
                    </label>
                  </div>

                  <table class="table table-bordered table-hover clearfix">
                    <thead>
                    <tr>
                      <th> File Column</th>
                      <th> Fields in File</th>
                      <th> Fields in CaseMGR</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(field, fi) in importFields.file">
                      <td> {{ fi+1 }}</td>
                      <td> {{ field }}</td>
                      <td>
                        <select v-model="map.fields[fi]" class="form-control">
                          <option value=""> Select option...</option>
                          <option v-for="(option, oi) in importFields.form" :value="oi"
                                  v-if="!oi.includes('text-entry')">
                            {{ option }}
                          </option>
                        </select>
                      </td>
                    </tr>
                    </tbody>
                  </table>



                  <template v-if="profileFields.length && (!currentForm || (currentForm.module && currentForm.module.role !== 'profile'))">
                    <hr>
                    <h5>Select key-field</h5>
                    <form data-vv-scope="key-field">
                      <table class="table table-bordered table-hover clearfix">
                        <thead>
                        <tr>
                          <th style="width: 50%">Fields in File</th>
                          <th>Fields in Profile form</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td :class="{ 'has-error': errors.has('key-field.in-file') }">
                            <select v-model="keyField.colInFile" class="form-control" v-validate="'required|integer'"
                                    data-vv-as="in-file" name="in-file">
                              <option> Select option...</option>
                              <option v-for="(option, oi) in importFields.file" :value="oi">[{{ oi }}] {{
                                  option
                                }}
                              </option>
                            </select>
                            <span v-show="errors.has('key-field.in-file')"
                                  class="help-block">{{ errors.first('key-field.in-file') }}</span>
                          </td>
                          <td :class="{ 'has-error': errors.has('key-field.in-profile') }">
                            <select class="form-control" id="key-field" v-model="keyField.fieldInForm"
                                    v-validate="'required'" data-vv-as="in-profile" name="in-profile">
                              <option v-for="field in profileFields" :value="field.name">{{
                                  field.description
                                }}
                              </option>
                            </select>
                            <span v-show="errors.has('key-field.in-profile')"
                                  class="help-block ">{{ errors.first('key-field.in-profile') }}</span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </form>
                  </template>
                </div>
              </tab-content>
              <tab-content title="Import Confirmation" icon="fa fa-cogs">
                <div>
                  <p>
                    {{ summary.successCount }} of {{ summary.count }} records to be imported.
                  </p>
                  <div v-if="summary.exceptionsCount !== 0"
                       class="vue-good-table"
                       style="margin-bottom:20px;"
                  >

                    <p>
                      <strong>Exceptions</strong>
                    </p>
                    <vue-good-table
                      mode="remote"
                      class="scrollable-table exceptions-table"
                      :columns="summary.columns"
                      :rows="summary.exceptions"
                      :paginate="false"
                    >

                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'rowIdx'">{{ props.row.rowIdx }}</span>
                        <span v-if="props.formattedRow[props.column.field].message"
                              style="color: #f00">{{ props.formattedRow[props.column.field].message }}</span>
                        <span v-else>{{ props.formattedRow[props.column.field].value }}</span>
                      </template>

                    </vue-good-table>
                  </div>
                </div>

                <spinner v-if="loading"/>
                <div v-else>
                  <p>
                    <button v-if="(summary.import != null)"
                            @click.prevent="runImportScript()"
                            class="btn green"
                            style="margin: 40px auto 0 auto; display: block;">Run Import
                    </button>
                  </p>
                </div>

              </tab-content>

              <template slot="footer" slot-scope="props">
                <div class=wizard-footer-left>
                  <wizard-button v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()"
                                 :style="props.fillButtonStyle">Previous
                  </wizard-button>
                </div>
                <div class="wizard-footer-right" v-if="props.activeTabIndex !== 0">
                  <wizard-button v-if="props.activeTabIndex === 1 && importFields.file != null"
                                 @click.native="preValidateImport()"
                                 class="wizard-footer-right margin-left" :style="props.fillButtonStyle"
                                 style="margin-left: 10px">Next
                  </wizard-button>

                  <wizard-button v-if="props.isLastStep && summary.success && showLastStepButtons"
                                 @click.native="cancelImport()"
                                 class="wizard-footer-right finish-button grey-cancel"
                                 :style="props.fillButtonStyle">Cancel Import
                  </wizard-button>

                  <wizard-button v-if="props.isLastStep && summary.success && showLastStepButtons"
                                 @click.native="createImport()" class="wizard-footer-right finish-button"
                                 :style="props.fillButtonStyle">Create Import
                  </wizard-button>
                </div>
              </template>
            </form-wizard>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import VueUploadComponent from 'vue-upload-component';
import Breadcrumbs from '@/components/Breadcrumbs';
import Spinner from '@/components/Spinner';
import {HTTP} from '@/http-common';
import ActionsMenu from "../components/reusables/ActionsMenu";
import ActionsMenuItem from "../components/reusables/ActionsMenuItem";

export default {
  data() {
    return {
      files: [],
      loading: false,
      columns: [
        {
          label: 'Name',
          field: 'name',
          filterOptions: {enabled: false}
        },
        {
          label: 'Description',
          field: 'description',
          filterOptions: {enabled: false}
        },
        {
          label: 'Created By',
          field: 'createdBy',
          filterOptions: {enabled: false}
        },
        {
          label: 'Last Modified',
          field: 'lastModified',
          filterOptions: {enabled: false}
        },
        {
          label: 'Action',
          field: 'after',
          filterOptions: {enabled: false}
        }
      ],
      ignoreRequired: false,
      currentForm: {},
      profileFields: [],
      map: {
        fields: []
      },
      keyField: {
        formId: null,
        colInFile: null,
        fieldInForm: null
      },
      showLastStepButtons: false
    }
  },
  components: {
    Breadcrumbs,
    VueUploadComponent,
    Spinner,
    ActionsMenu,
    ActionsMenuItem,
  },
  inject: {
    $validator: '$validator'
  },
  created() {
    this.setImportsStep(1)
    this.getImportsForms()
  },
  computed: {
    ...mapGetters({
      step: 'getImportsStep',
      forms: 'getImportsForms',
      importFields: 'getImportsFields',
      filename: 'getImportsFilename',
      form: 'getImportsForm',
      importStatus: 'getImportStatus',
      summary: 'getImportsSummary',
      importId: 'getImportId'
    })
  },
  methods: {
    ...mapActions({
      setImportsStep: 'SET_IMPORTS_STEP_ACTION',
      getImportsForms: 'GET_IMPORTS_FORMS_ACTION',
      getImportsTemplate: 'GET_IMPORTS_TEMPLATE_ACTION',
      importsUpload: 'IMPORTS_UPLOAD_ACTION',
      importsValidate: 'IMPORTS_VALIDATE_ACTION',
      importCreate: 'IMPORT_CREATE_ACTION',
      exportExceptions: 'IMPORTS_EXPORT_EXCEPTIONS',
      importRun: 'IMPORT_RUN_ACTION'
    }),
    back(step) {
      this.setImportsStep(step)
      if (step === 1) {
        this.map.fields = []
      }
    },
    uploadFile(formId) {
      this.$store.commit('RESET_IMPORTS_FIELDS');
      this.$store.commit('SET_IMPORT_FORM_ID', formId);
      this.map.fields = [];
      this.files = [];

      HTTP.post('form/get', {
        id: formId
      }).then(response => {
        this.currentForm = response.data.data;
        this.$refs.wizard.nextTab();
      }).catch(err => {
        console.log(err)
        this.$notify({'type': 'error', 'text': 'Invalid form'});
      })

      HTTP.get('form-builder/system-forms').then(response => {

        let profileForm = response.data.data.system_forms.profile;

        this.profileFields = JSON.parse(profileForm.data);
        this.keyField.formId = profileForm.id;

        let profileColumnsMap = JSON.parse(profileForm.columns_map);
        let systemIdField = profileColumnsMap.find(col => col.name === 'system_id');

        if (systemIdField !== undefined) {
          if (this.profileFields.find(field => field.name === systemIdField.value) !== undefined) {
            this.keyField.fieldInForm = systemIdField.value;
          }
        }

      }).catch(err => {
        this.$notify({'type': 'error', 'text': 'Invalid profile form. Key field selection not available.'});
      });
    },

    validateUploadAsync() {
      let fd = new FormData();
      let blob;
      let self = this;

      let context = Ladda.create(document.querySelector('.fileUpload'));
      context.start();

      this.files.forEach((file, index) => {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', file.blob, true);
        xhr.responseType = 'blob';
        xhr.onload = function (e) {
          if (this.status === 200) {
            blob = this.response;
            self.filename_org = file.name;
            fd.append(file.name, blob);
            self.importsUpload({fd, name: file.name})
              .then((r) => {
                if (r.data.status === 'error') {
                  self.$notify({type: 'error', text: 'Upload failed, please try again later'});
                }
              })
              .finally(() => {
                context.stop();
              })
          }
        };
        xhr.send();
      });

    },
    preValidateImport() {
      this.$validator.validateAll('key-field').then((result) => {
        if (result) {
          this.loading = true;
          this.importsValidate({
            ref: this,
            context: this.$refs.wizard,
            map: this.map.fields,
            key_field: this.keyField,
            ignore_required: this.ignoreRequired,
          }).then(
            this.showLastStepButtons = true
          );
        }
      });
    },
    createImport() {
      this.loading = true;
      this.importCreate({
        ref: this,
      }).then((response) => {
        if (response.data.status === 'success') {
          this.showLastStepButtons = false;
          this.importRun({id: response.data.data.import.id});
          this.$router.push({name: 'Imports History'});
        }
      })
    },
    exportTemplate(id) {
      this.getImportsTemplate(id);
    },
    showModification(data) {
      return (data.user != null)
    },
    cancelImport() {
      this.$router.push({name: 'Imports Select'});
    },
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(csv)$/i.test(newFile.name)) {
          this.$notify({
            type: 'error',
            text: '<b>CSV</b> file is required.'
          });
          return prevent()
        }
      }
      newFile.blob = ''
      let URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file)
      }
    },
  },
  watch: {
    importFields: function (newVal) {
      if (!newVal.hasOwnProperty('file') || !newVal.file.length) {
        this.map.fields = [];
        return;
      }

      newVal.file.forEach((item, idx) => {
        let key = (Object.keys(newVal.form).find(key =>
          newVal.form[key] === item
        ));

        if (key !== undefined) {
          this.map.fields[idx] = key;
        }

        if (item === 'System ID') {
          this.keyField.colInFile = idx;
        }
      });
    }
  }
}
</script>

<style scoped>
.grey-cancel {
  color: #666 !important;
  background-color: #e1e5ec !important;
  border-color: #e1e5ec !important;
  margin-left: 10px;
}

.last-dropdown {
  width: 170px;
}

.upload-line {
  display: flex;
  align-items: center;
}

.uplaod-line ul {
  margin: 0;
}

.vue-form-wizard .navbar .navbar-nav > li > a.wizard-btn, .vue-form-wizard .wizard-btn {
  font-weight: 400;
  min-width: initial;
}
</style>



// WEBPACK FOOTER //
// Imports.vue?aa84262c